import {useNavbar} from "../states/common/client";
import React, {useEffect, useState} from "react";
import {Box, IconButton, List, ListItem, ListItemText, Switch} from "@mui/material";
import {AlfyButton} from "../components/AlfyButton";
import {useUserMe} from "../states/user/server";
import {useGetUserMeSettings, useUpdateSettings} from "../states/user/hooks";
import {alfyToast} from "../utils/Utils";

export const NotificationSettingPage = () => {
    const [isEmailNotificationOn, setIsEmailNotificationOn] = useState<boolean>(false)

    const { reset, setNavbarTitle } = useNavbar()

    const { data: user } = useUserMe()
    const { data: userSettings, isLoading } = useGetUserMeSettings()

    const { mutateAsync: updateSettings } = useUpdateSettings()

    const email = user?.email ?? 'unknown'

    const handleSave = async () => {
        await updateSettings({ emailNotification: isEmailNotificationOn, kakaoAlimTalkNotification: false })
            .then(() => {
                alfyToast('알림 설정이 저장되었습니다.')
            })
            .catch(() => {
                alfyToast('알림 설정 저장에 실패했습니다.')
            })
    }

    const handleChange = (checked: boolean) => {
        setIsEmailNotificationOn(checked)
    }

    useEffect(() => {
        reset()
        setNavbarTitle('알림 설정')
    }, []);

    if (isLoading || !userSettings) {
        return <div>불러오는 중...</div>
    }

    return (
        <div className={"fullscreen"}>
            <List>
                <ListItem
                    secondaryAction={
                    <IconButton>
                        <Switch onChange={(_, checked) => handleChange(checked)}
                                defaultChecked={userSettings.emailNotification}
                        />
                    </IconButton>}
                    sx={{paddingY: '20px'}}
                ><ListItemText primary={'이메일 알림'} secondary={`${email}로 약속 알림 받기`} /></ListItem>
                <ListItem
                    secondaryAction={<IconButton><Switch disabled/></IconButton>}
                    sx={{paddingY: '20px'}}
                >카카오 알림톡
                </ListItem>
            </List>
            <Box height={'30px'} />
            <AlfyButton text={'저장'} onClick={handleSave} />
        </div>
    )
}